var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetsInventoryManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362.5 116.5v12c-47.7-22.1-132.5-61.2-181-83.7-48.9 22.6-132.9 61.5-181 83.7v-12c47.8-22.1 132.5-61.3 181-83.7 48.8 22.6 132.9 61.5 181 83.7z",
    fill: "#5a6bf2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362.5 96.8v19.7c-47.8-22.1-132.5-61.2-181-83.7-48.9 22.6-132.9 61.5-181 83.7v-19.7c3.4-1.6 186.5-86.2 181-83.7 5.3 2.5 170.3 78.8 181 83.7z",
    fill: "#798af5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m511.6 245v10.6c-47.8-22-132.6-61.3-181.1-83.7v-10.6c48.8 22.6 133 61.5 181.1 83.7z",
    fill: "#5a6bf2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m511.6 223.9v21.1c-47.8-22-132.6-61.3-181.1-83.7v-21.1c0-.1 17 7.9 17 7.9s164.1 75.8 164.1 75.8z",
    fill: "#798af5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m202.4 54.4c-30.2 14-98.7 45.7-128.2 59.3v203.3h-11.7c-1.8 0-3.3 1.5-3.3 3.3v84.3c0 1.8 1.5 3.3 3.3 3.3-1.8 0-3.3 1.4-3.3 3.3v24.4h-26.8v-321.9c31-14.3 116.9-54.1 149-69z",
    fill: "#d5dae7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m479.6 240.7v194.9h-149v-263.8c32.4 15 117.7 54.4 149 68.9z",
    fill: "#d5dae7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m330.6 171.8v263.8h-89.6v-24.4c0-1.8-1.5-3.3-3.3-3.3h-84.3c-1.8 0-3.3 1.4-3.3 3.3 0-1.8-1.4-3.3-3.3-3.3 1.8 0 3.3-1.5 3.3-3.3v-84.3c0-1.8-1.4-3.3-3.3-3.3h-72.6v-203.3c29.2-13.5 98.3-45.5 128.2-59.3 30.1 13.9 98.7 45.7 128.1 59.3z",
    fill: "#e5e8f3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m291.5 177.5v258.2h-50.5v-24.4c0-1.8-1.5-3.3-3.3-3.3h-84.3c-1.8 0-3.3 1.4-3.3 3.3 0-1.8-1.4-3.3-3.3-3.3 1.8 0 3.3-1.5 3.3-3.3v-84.3c0-1.8-1.4-3.3-3.3-3.3h-72.6v-139.6z",
    fill: "#56778f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m149.5 498.9h-89.7c-.3 0-.6-.3-.6-.6v-89.7c0-.3.3-.6.6-.6h89.7c.3 0 .6.3.6.6v89.7c0 .3-.3.6-.6.6z",
    fill: "#f0be5f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m90.4 408h28.5v39.6h-28.5z",
    fill: "#e5e8f3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m149.5 408h-89.7c-.3 0-.6-.3-.6-.6v-89.7c0-.3.3-.6.6-.6h89.7c.3 0 .6.3.6.6v89.7c0 .3-.3.6-.6.6z",
    fill: "#f0be5f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m90.4 317.1h28.5v39.6h-28.5z",
    fill: "#e5e8f3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m173.7 498.9h-20.4c-1.8 0-3.3-1.5-3.3-3.3v-84.3c0-1.8 1.5-3.3 3.3-3.3h20.4c-1.8 0-3.3 1.5-3.3 3.3v84.3c0 1.8 1.5 3.3 3.3 3.3z",
    fill: "#e5af56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m82.9 498.9h-20.4c-1.8 0-3.3-1.5-3.3-3.3v-84.3c0-1.8 1.5-3.3 3.3-3.3h20.4c-1.8 0-3.3 1.5-3.3 3.3v84.3c0 1.8 1.5 3.3 3.3 3.3z",
    fill: "#e5af56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m82.9 408h-20.4c-1.8 0-3.3-1.5-3.3-3.3v-84.3c0-1.8 1.5-3.3 3.3-3.3h20.4c-1.8 0-3.3 1.5-3.3 3.3v84.3c0 1.8 1.5 3.3 3.3 3.3z",
    fill: "#e5af56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m241 411.3v84.3c0 1.8-1.5 3.3-3.3 3.3h-63.9c-1.8 0-3.3-1.5-3.3-3.3v-84.3c0-1.8 1.5-3.3 3.3-3.3h63.9c1.8 0 3.3 1.5 3.3 3.3z",
    fill: "#f0be5f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m181.3 408h28.5v39.6h-28.5z",
    fill: "#e5e8f3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m330.5 263.8h24.2v171.8h-24.2z",
    fill: "#416079"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m74.2 177.4h24.2v139.6h-24.2z",
    fill: "#416079"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m354.7 263.8h90.9v171.8h-90.9z",
    fill: "#56778f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m130.9 119.1h24.8v28.9h-24.8z",
    fill: "#416079"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m155.6 119.1h76.4v28.9h-76.4z",
    fill: "#56778f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m74.2 177.5h217.3v23.9h-217.3z",
    fill: "#5a6bf2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m74.2 201.3h217.3v23.9h-217.3z",
    fill: "#798af5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m74.2 225.2h217.3v23.9h-217.3z",
    fill: "#5a6bf2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsInventoryManagement);
export default __webpack_public_path__ + "static/media/assets-inventory-management.b8697722361a48dc90bf1441f55551f4.svg";
export { ForwardRef as ReactComponent };